import { IColumn } from 'interfaces/shared.interface';

// Widths total ~1345px. Dropping the 20rem sidebar for a top bar returned about 320px to
// the content area, which is what makes these comfortable rather than grudging.
// Previously they totalled 1119px and everything fought for room.
// Sized so the actions column is reachable
// without scrolling at a normal window and the whole table scrolls below that rather than
// every column being squeezed. Each is sized to its longest real value: "SUBSCRIPTION",
// "dd.MM.yyyy", "dd.MM.yyyy HH:mm". Modules gets what is left because it is the one column
// designed to truncate - two chips plus a counter, full list on hover and in the modal. "Модули" is wide enough for two chips
// plus a "+N" counter; the full list is on the cell's title and in the view modal.
export const LICENSE_TABLE_COLUMNS: IColumn[] = [
  { key: 'clientId', width: 140 },
  { key: 'type', width: 130 },
  { key: 'status', width: 105 },
  { key: 'startDate', width: 110 },
  { key: 'endDate', width: 110 },
  { key: 'maxEndpoints', width: 95 },
  { key: 'modules', width: 250 },
  { key: 'createdDate', width: 150 },
  { key: 'agent', width: 160 },
  { key: 'actions', width: 140 },
];

export const PAGE_SIZE_OPTIONS = [10, 20, 50];
